/*eslint no-script-url: 0 */
import React, { Component } from "react";
import QuickMenu from './Components/Footer/QuickMenu';
import OtherMenu from './Components/Footer/OtherMenu';
import ContactUs from './Components/Footer/ContactUs';
import Constants from './Config/Config';
import $ from 'jquery';

class Footer extends Component {

	getCartQty() {
  		var self = this;
  		const cartQtyURL = Constants.URL.root+'/wp-admin/admin-ajax.php';
  		$.ajax(cartQtyURL, {
			method: "POST",
			data: 'action=get_cart_qty',
			success: function (res) {
				self.props.dispatch({
					type: 'SET_STATE',
					state: {
						cartQty: res
					}
				})
			}
		});
	}

	componentDidMount() {
		this.getCartQty();
	}

  	render() {
	    return (
	    	<div>
		    	<footer className="full_width">
					<div className="container">
						<div className="row">
							<QuickMenu />
							<OtherMenu />
							<ContactUs />
						</div>
					</div>
				</footer>
				<div className="footer_bot full_width">
					<div className="container">
						<p> &copy; {new Date().getFullYear()} Just Picture Framing Online. </p>
					</div>
				</div>
			</div>
	    );
  	}
}

export default Footer;